import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/AboutOur.css'; // ✅ Create this CSS file

gsap.registerPlugin(ScrollTrigger);

const AboutOur = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Text animation - replays on each scroll
      gsap.fromTo(textRef.current,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Image animation - replays on each scroll
      gsap.fromTo(imageRef.current,
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="aboutour-container" ref={sectionRef}>
      <div className="aboutour-text" ref={textRef}>
        <h2>About Us:</h2>
        <p>

Automotive Devices was founded in Lahore by two professional engineers with extensive experience in consumer and industrial electronics product development. Recognizing a clear gap in the market for truly professional PCBA assembly services, they established a company built on technical precision, consistent quality, and responsive customer support.

From the outset, the focus has been on delivering accuracy and reliability in every stage of electronics manufacturing. Over time, Automotive Devices has expanded its capabilities by integrating advanced SMT technologies and modern inspection systems to meet evolving industry standards.

Today, the company continues to operate on its founding principles: flexibility, attention to detail, and a strong commitment to customer satisfaction. We collaborate with clients across diverse requirements—from single prototypes to high-volume production—ensuring precise and dependable PCBA assembly at every scale.

With a solid foundation in engineering expertise and manufacturing excellence, Automotive Devices is ready to support your next project with confidence and precision.
        </p>
      </div>
      <div className="aboutour-image" ref={imageRef}>
        <img src="/about.png" alt="About Automotive Devices" />
      </div>
    </div>
  );
};

export default AboutOur;
